module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-milk.d354b7aa.svg";